import React from "react";
import { useSnackbar } from "notistack";

import CloseButton from "./CloseButton";

export const CloseAction = (key: number) => {
  const { closeSnackbar } = useSnackbar();

  const handleClose = () => {
    closeSnackbar(key);
  };

  return <CloseButton onClose={handleClose} />;
};
